module.exports = __webpack_public_path__ + "img/wardrobe.21eac917.svg";